import * as React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    onSend: () => void,
    onCancel: () => void
}

const TriggerRexmEmail: React.FunctionComponent<IProps> = (props) => {
    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>REXM Email</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div style={{ marginBottom: 20 }}>Are you sure you wish to trigger an REXM email?</div>
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle="primary" onClick={props.onSend}>Yes</Button>
                <Button onClick={props.onCancel}>No</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default TriggerRexmEmail;